// extracted by mini-css-extract-plugin
export default {"container":"NavigatorArrows_container__EbUrT","leftLink":"NavigatorArrows_leftLink__CHZiL","rightLink":"NavigatorArrows_rightLink__n9rQo","icon":"NavigatorArrows_icon__GnkuL"};